export default __webpack_public_path__ + "static/timberline-28-ORBITAL-SCRUBBER-MANUFACTURING-FACILITY.807457031-1cb6fa90c6926d9124853f0e209376ce.jpg";